const PayFrequencies = ["WEEKLY", "MONTHLY"];

export const PAY_FREQUENCIES = PayFrequencies;
const PayFrequenciesV2 = ["BIWEEKLY"];

export const PAY_FREQUENCIES_V2 = PayFrequenciesV2;

const PayFrequency = {
	weekly: "WEEKLY",
	monthly: "MONTHLY"
};
const PayFrequencyV2 = {
	biweekly: "BIWEEKLY"
};

const PayFrequencyV3 = {
	weekly: "WEEKLY",
	monthly: "MONTHLY",
	biweekly: "BIWEEKLY"
};

export const PAY_FREQUENCY = PayFrequency;
export const PAY_FREQUENCY_V2 = PayFrequencyV2;

const PayFrequenciesV3 = ["WEEKLY", "MONTHLY", "BIWEEKLY"];

export const PAY_FREQUENCY_V3 = PayFrequenciesV3;
export const PAY_FREQUENCIES_V3 = PayFrequencyV3;
